export default {
  tags: {
    articles: 'bz-article',
    paragraphs: 'bz-paragraph',
    texts: 'bz-text'
  },
  allowedChildren: {
    articles: ['paragraphs', 'texts'],
    paragraphs: ['texts']
  },
  componentProps: {
    articles: ['title'],
    paragraphs: ['title'],
    texts: ['html', 'markdown', 'language']
  },
  translatableProps: {
    articles: ['title'],
    paragraphs: ['title'],
    texts: ['html', 'markdown']
  },
  defaultLocale: 'en'
}



// WEBPACK FOOTER //
// ./src/bz-config.js